import { track } from "../track";

export const trackAvatarEditClick = (params: { avatar_id: string }) =>
  track({ event: "avatar_edit_click", ...params });
